<script>
import { authComputed } from '@state/helpers'
import NavBarRoutes from './nav-bar-routes.vue'

import ClockWrapper from '@components/clock/clockWrapper.vue'

import menuRoutes from '@router/menuRoutes.js'

const appVersion = process.env.VUE_APP_VERSION

export default {
  components: { NavBarRoutes, ClockWrapper },
  data() {
    return {
      version: appVersion,
      showMenu: false,
      persistentNavRoutes: [
        // {
        //   name: 'home',
        //   title: 'Overview',
        // },
      ],
      loggedInNavRoutes: [],
      loggedInNavRoutesFlight: [
        {
          name: 'flights',
          title: 'Flight List',
        },
        {
          name: 'flightsboard',
          title: 'Flights Board',
        },
      ],
      loggedInNavRoutesSystemUsage: menuRoutes.loggedInNavRoutesSystemUsage,
      navRoutePaxTotals: menuRoutes.navRoutePaxTotals,
      navRouteKiosk: menuRoutes.loggedInNavRoutesKiosk,
      loggedOutNavRoutes: [
        {
          name: 'login',
          title: 'Log in',
        },
      ],
    }
  },
  computed: {
    ...authComputed,
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu
    },
  },
}
</script>

<template>
  <!-- <div>
      <ul class="side-menu">
        <ul class="navbar-nav d-lg-block">
          <NavBarRoutes :routes="persistentNavRoutes" />
          <div class="nav-header text-small text-muted">Flights</div>
          <NavBarRoutes v-if="loggedIn" :routes="loggedInNavRoutesFlight" />

          <div class="nav-header text-small text-muted">Passenger Totals</div>
          <NavBarRoutes v-if="loggedIn" :routes="navRoutePaxTotals" />

          <div class="nav-header text-small text-muted">System Usage</div>
          <NavBarRoutes
            v-if="loggedIn"
            :routes="loggedInNavRoutesSystemUsage"
          />

          <NavBarRoutes v-if="loggedIn" :routes="loggedInNavRoutes" />
          <NavBarRoutes v-else :routes="loggedOutNavRoutes" />
        </ul>
      </ul>
  </div>-->
  <div class="navbar navbar-expand-lg bg-dark navbar-dark sticky-top">
    <a class="navbar-brand text-white" to="/home">
      <span class="fw-600">L-DCS</span> |
      <span class="fw-300">Insight</span>
      <div class="beta ver">v{{version}}</div>
    </a>
    <ClockWrapper class="mb-3 scale-down clock-wrapper" />
    <div class="d-flex align-items-center">
      <button
        class="navbar-toggler b-0"
        type="button"
        data-toggle="collapse"
        data-target="#navbar-collapse"
        aria-controls="navbar-collapse"
        :aria-expanded="showMenu"
        aria-label="Toggle navigation"
        @click="toggleMenu"
      >
        <div id="nav-icon3" :class="showMenu ? 'isOpen' : ''">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>
    </div>
    <div
      id="navbar-collapse"
      class="navbar-collapse flex-column collapse transition"
      :class="showMenu ? 'show' : 'hide'"
    >
      <ul class="navbar-nav d-lg-block">
        <NavBarRoutes :routes="persistentNavRoutes" />
        <div class="nav-header text-small text-muted">Flights</div>
        <NavBarRoutes v-if="loggedIn" :routes="loggedInNavRoutesFlight" />
        <hr />
        <div class="nav-header text-small text-muted">Passenger Totals</div>
        <NavBarRoutes v-if="loggedIn" :routes="navRoutePaxTotals" />
        <hr />
        <div class="nav-header text-small text-muted">System Usage</div>
        <NavBarRoutes v-if="loggedIn" :routes="loggedInNavRoutesSystemUsage" />

        <hr />
        <div class="nav-header text-small text-muted">Kiosk</div>
        <NavBarRoutes v-if="loggedIn" :routes="navRouteKiosk" />

        <NavBarRoutes v-if="loggedIn" :routes="loggedInNavRoutes" />

        <NavBarRoutes v-else :routes="loggedOutNavRoutes" />
      </ul>
      <ul class="navbar-nav d-lg-block"></ul>
      <!-- <hr /> -->
      <!-- <div class="d-none d-lg-block w-100">
        <span class="text-small text-muted">Quick Links</span>
        <ul class="nav nav-small flex-column mt-2">
          <li class="nav-item">
            <router-link to="/profile" class="nav-link">Profile</router-link>
          </li>
        </ul>
        <hr />
      </div>-->
    </div>
    <div class="d-none d-lg-block">
      <div v-if="currentUser">
        <b-dropdown
          size="sm"
          variant="outline-info"
          dropup
          toggle-class="text-decoration-none"
          no-caret
        >
          <template v-slot:button-content>
            <b-icon icon="people-fill"></b-icon>
            {{ currentUser.FullName }}
          </template>
          <b-dropdown-item to="/profile">Profile</b-dropdown-item>
          <b-dropdown-item to="/logout">Logout</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </div>
</template>


<style lang="scss">
.container {
  padding: 0;
  // margin: 0 0 $size-grid-padding;
  text-align: center;
  list-style-type: none;

  > li {
    display: inline-block;
    // margin-right: $size-grid-padding;
  }
}

.scale-down {
  transform: scale(0.94);
  margin-left: -8px;
}
.clock-wrapper {
  // background: #0000004f;
  //   padding: 5px;
  border-radius: 6px;
  margin-left: -10px;
}
</style>
